import { Layout, Margin } from "plotly.js";
import React, { useState } from "react";
import Plot from "react-plotly.js";

type EcgGridProps = {
    speed: number,
    amplitude: number,
    ecgData: any[]
};

const ECGGrid = (props: EcgGridProps) => {
    const {speed, amplitude, ecgData} = props;

  const data: Object[] = [];
  
  const generateGridLines = (spacing: number, color: string, lineWidth: number) => {
    const lines: Partial<Plotly.Shape>[] = [];
    // Generate vertical lines
    for (let x = -20; x <= (265 * (speed / 25)); x += spacing) {
      if (x%5 == 0 && spacing == 1) { continue; }
      lines.push({
        layer: "below",
        type: "line",
        x0: x,
        x1: x,
        y0: -10,
        y1: 185,
        line: { color, width: lineWidth },
      });
    }
    // Generate horizontal lines
    for (let y = -10; y <= 185; y += spacing) {
      if (y%5 == 0 && spacing == 1) { continue; }
      lines.push({
        layer: "below",
        type: "line",
        x0: -20,
        x1: (265 * (speed / 25)),
        y0: y,
        y1: y,
        line: { color, width: lineWidth },
      });
    }
    return lines;
  };

  // Small grid lines
  const smallGrid: Partial<Plotly.Shape>[] = generateGridLines(1, "#F6D8DA", 0.5);

  // Large grid lines
  const largeGrid: Partial<Plotly.Shape>[] = generateGridLines(5, "#F48284", 1.5);

  // {
  //   x: ecgData[0].x,
  //   y: ecgData[0].y,
  //   mode: "lines",
  //   //type: "scattergl",
  //   line: { color: "black", width: 1 },
  // }, // mm/mV

  const timePerSecond = 1000;
  const timeInterval = timePerSecond / ecgData[0].sampleRate;

  let k = 170;
  ecgData.forEach(element => {
    data.push({
        type: "scatter",
        mode: "text",
        layer: "above",
        x: [-15],
        y: [k],
        text: element.lead,
        textfont: {
          color: "#0000ff",
          weight: "bold",
          size: 15
        }
      }
    );
    let leadData = element.data.slice(1, element.data.length);
    let initialValue = leadData[0] * (amplitude / 10) / 100;
    data.push({
    // const data = ecgData.map((leadData, index) => ({
      x: Array.from({ length: leadData.length }, (_, i) => i * timeInterval * (speed / 25) / 40),
      y: leadData.map((val: any) => (val * (amplitude / 10) / 100) + k),
      name: element.lead,
      text: "1234",
      type: "scatter",
      mode: "line",
      line: { width: 1.5, color: '#555555' },
    });
    let j = -370;//leadData.length;
    let x = [];
    let y = [];
    for (let i = 1; i <= 320; i++) {
      x.push(( (j + i) * timeInterval * (speed / 25) / 40));
      if (i>80 && i<240)
        y.push(k+10+initialValue);
      else
        y.push(k+initialValue);
    }
    data.push({
      // const data = ecgData.map((leadData, index) => ({
        x: x,
        y: y,
        // name: element.lead,
        text: "1234",
        type: "scatter",
        mode: "line",
        line: { width: 1.5, color: '#555555' },
      });
    k = k - 15;
    // }));
  });
  data.push({
      type: "scatter",
      mode: "text",
      layer: "above",
      x: [-5],
      y: [k+2],
      text: '25 mm/s 10 mm/mV',
      textfont: {
        color: "#000000",
        weight: "bold",
        size: 12
      }
    }
  );

  const margin: Partial<Plotly.Margin> = {
      t : 0,
      r : 0,
      l : 0,
      b : 0,
  };

  const layout: Partial<Plotly.Layout> = {
      width: (1650 * (speed / 25)),
      height: 1240,
      margin: margin,
      dragmode: false,
      showlegend: false,
      hovermode: false,
      title: {
        
      },
      xaxis: { range: [-20, (265 * (speed / 25))], showgrid: false, zeroline: false, title: {}, showticklabels: false, },
      yaxis: { range: [-10, 185], showgrid: false, zeroline: false, title: {}, showticklabels: false, },
      shapes: [...smallGrid, ...largeGrid],
    };

  return (
      <Plot
        data={data}
        layout={layout}
        config={{ responsive: true, displayModeBar: false }}
      ></Plot>
  );
};

export default ECGGrid;
